<script lang="ts">

    export let BaseChar : number;
    export let Count : number;

    let Table : string[] = [
        "null (null)",
        "SOH (start of heading)",
        "STX (start of text)",
        "ETX (end of text)",
        "EOT (end of transmission)",
        "ENQ (enquiry)",
        "ACK (acknowledge)",
        "DEL (delete)",
        "BS (backspace)",
        "TAB (horizontal tab)",
        "LF (newline)",
        "VT (vertical tab)",
        "FF (form feed)",
        "CR (carriage return)",
        "SO (shift out)",
        "SI (shift in)",
        "DLE (data link escape)",
        "DC1 (device control 1)",
        "DC2 (device control 2)",
        "DC3 (device control 3)",
        "DC4 (device control 4)",
        "NAK (negative acknowledge)",
        "SYN (synchronous idle)",
        "ETB (end of transmission block)",
        "CAN (cancel)",
        "EM (end of medium)",
        "SUB (substitute)",
        "ESC (escape)",
        "FS (file separator)",
        "GS (group separator)",
        "RS (record separator)",
        "US (unit separator)",
        "Space"
    ];
 
    function range(size, startAt = 0) {
        return [...Array(size).keys()].map(i => i + startAt);
    }
</script>

<table class="table">
    <thead>
        <tr>
            <th><abbr title="Decimal">DEC</abbr></th>
            <th><abbr title="Hexadecimal">HEX</abbr></th>
            <th><abbr title="Octal">OCT</abbr></th>
            <th><abbr title="ASCII">ASCII</abbr></th>
        </tr>
    </thead>
    <tbody>
        {#each range(32) as _, i} 
            <tr>
                <td>{(i + BaseChar).toString()}</td>
                <td>{(i + BaseChar).toString(16)}</td>
                <td>{(i + BaseChar).toString(8)}</td>
                {#if (i + BaseChar) <= 32}
                    <td>{Table[i + BaseChar]}</td>
                {:else}
                    <td>{String.fromCharCode(i + BaseChar)}</td>
                {/if}
            </tr>  
        {/each}
    </tbody>
</table>
